import React from "react";
import * as PR from "../../prime-modules/index";
import "./Affiliates.scss";

const AffiliateUsersDialog = ({ affiliate, onHide, onToggleUserStatus, getRoleName }) => {
    const affiliateUsers = affiliate?.affiliateUsers || [];

    const header = (
        <div className="affiliate-users-dialog-header">
            <span className="title">Affiliate Users</span>
            {affiliate?.name && (
                <span className="sub-title">
                    {affiliate.name}
                    <span className="users-count">
                        {affiliateUsers.length} {affiliateUsers.length === 1 ? "user" : "users"}
                    </span>
                </span>
            )}
        </div>
    );

    const userNameTemplate = (row) => (
        <div className="affiliate-user-cell">
            <span className="affiliate-user-cell__label">User</span>
            <div className="aff-data">
                {row?.name || "-"}
                <span>{getRoleName ? getRoleName(row?.role) : "-"}</span>
            </div>
        </div>
    );

    const emailTemplate = (row) => (
        <div className="affiliate-user-cell">
            <span className="affiliate-user-cell__label">Email</span>
            <span className="email-column">{row?.email || "-"}</span>
        </div>
    );

    const statusTemplate = (row) => (
        <div className="affiliate-user-cell" onClick={(e) => e.stopPropagation()}>
            <span className="affiliate-user-cell__label">Status</span>
            <span><PR.InputSwitch checked={!!row?.isActive} onChange={() => onToggleUserStatus?.(row)} /></span>
        </div>
    );

    return (
        <PR.Dialog
            visible={!!affiliate}
            dismissableMask={true}
            draggable={false}
            resizable={false}
            header={header}
            onHide={onHide}
            className="affiliate-dialog affiliate-users-dialog"
            maskClassName="affiliate-dialog-mask"
        >
            <PR.DataTable
                value={affiliateUsers}
                dataKey="id"
                className="vouchers-table affiliate-users-table"
                paginator={affiliateUsers.length > 10}
                rows={10}
                scrollable
                scrollHeight="55vh"
                emptyMessage={<span className="text-gray-500">No affiliate users found</span>}
            >
                <PR.Column header="User Name" body={userNameTemplate} style={{ width: "30%" }} className="user-name-column" />
                <PR.Column header="Email" body={emailTemplate} style={{ width: "52%" }} className="user-email-column" />
                <PR.Column
                    header="Status"
                    field="isActive"
                    body={statusTemplate}
                    sortable
                    style={{ width: "18%" }}
                    className="status-column"
                    headerClassName="status-header"
                />
            </PR.DataTable>
        </PR.Dialog>
    );
};

export default AffiliateUsersDialog;
